const env = process.env;

export const API_URL = env.REACT_APP_BASE_URL || '';
export const FRONTEND_URL = env.REACT_APP_UI_URL || '';
export const GA_ID = env.REACT_APP_GA_ID || '';